export default __webpack_public_path__ + "img/61f3b89c1f098e40962d13e88d759a10.png";